function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
function formatRentalExpiry(ts) {
  var d = new Date(Number(ts));
  if (!Number.isFinite(d.getTime())) {
    return '';
  }
  return d.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}
module.exports = function (app, mod) {
  var games = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var rows = games.map(function (game) {
    var title = escapeHtml(game.title || 'Untitled ROM');
    var sig = escapeHtml(game.sig || '');
    var expiry = '';
    if (game.rental && game.expires_at != null) {
      var label = formatRentalExpiry(game.expires_at);
      if (label) {
        expiry = "Expires: ".concat(escapeHtml(label));
      }
    }
    return "\n        <tr class=\"row\" data-sig=\"".concat(sig, "\" tabindex=\"0\" role=\"button\">\n          <td class=\"name\">").concat(title, "</td>\n          <td class=\"expires\">").concat(expiry, "</td>\n          <td class=\"action\">\n            <button type=\"button\" class=\"saito-button-primary compact launch\" data-sig=\"").concat(sig, "\">\n              Play\n            </button>\n          </td>\n        </tr>\n      ");
  }).join('');
  var installed_body = '';
  if (!games.length) {
    installed_body = "\n      <div class=\"empty\">\n        <p>Upload and play your legal N64 ROMs.</p>\n        <p>Looking for games? <a class=\"saito-text-link\" href=\"/store\">Visit the Saito Store</a>.</p>\n      </div>\n    ";
  } else {
    installed_body = "\n      <div class=\"table-wrap\">\n        <table class=\"table\">\n          <tbody>".concat(rows, "</tbody>\n        </table>\n      </div>\n    ");
  }
  return "\n    <div class=\"nwasm-arcade-overlay\">\n      <div class=\"library\">\n        <section class=\"installed\">\n          <h2 class=\"section-title\">Your Games</h2>\n          ".concat(installed_body, "\n        </section>\n\n        <section class=\"upload-panel\">\n          <h2 class=\"section-title\">Upload Legal N64 ROM</h2>\n          <div\n            id=\"nwasm-arcade-upload\"\n            class=\"dropzone\"\n            role=\"button\"\n            tabindex=\"0\"\n            aria-label=\"Upload Legal N64 ROM\">\n            <div class=\"prompt\">Drag and drop a ROM to which you have legal access.</div>\n            <div class=\"state\" hidden>\n              <div class=\"saito-spinner\" aria-hidden=\"true\"></div>\n              <div class=\"status\">Preparing upload\u2026</div>\n            </div>\n          </div>\n        </section>\n      </div>\n    </div>\n  ");
};